import { Option } from '@vaaas/fpts/option';
import { PropType, defineComponent, h } from 'vue';

type ColorChangeEvent = Event & { detail: { value: string } };

export const Picker = defineComponent({
    props: {
        value: {
            required: true,
            type: null as any as PropType<Option<string>>,
        },
    },

    emits: {
        'update:value': (x: string) => true,
    },

    watch: {
        value(x: string) {
            this.sync_with_dom(x);
        },
    },

    methods: {
        on_color_changed(e : ColorChangeEvent) {
            this.$emit('update:value', e.detail.value);
        },

        sync_with_dom(x: string) {
            if (this.$refs.picker instanceof HTMLElement)
                this.$refs.picker.setAttribute('color', x);
        },
    },

    mounted() {
        this.sync_with_dom(this.value ?? '');
    },

    render() {
        return h('hex-color-picker', {
            ref: 'picker',
            color: this.value || 'black',
            onColorChanged: this.on_color_changed,
        });
    },
});
